export interface UWApprovalState {
  isLoading: boolean | null;
};
export const initialState = {
  isLoading: null
};